import axios from 'axios'
import store from './store'

class Api {
  async get (url) {
    try {
      // const { data } = await axios.get(url, { withCredentials: true })
      const response = await axios.get(url)
      if (response.status !== 200) {
        this.displayErrors(response)
      }
      return response.data
    } catch ({ response }) {
      this.displayErrors(response.data.errors)
      if (response !== undefined) {
        throw response
      }
    }
  }

  async call (requestType, url, payload) {
    console.log('API CALL ' + requestType + ' ' + url + ' ' + payload)
    try {
      const response = await axios({
        method: requestType,
        url: url,
        data: payload
      })
      // withCredentials: true
      if (response.status !== 200) {
        this.displayErrors(response)
      }
      return response.data
    } catch ({ response }) {
      this.displayErrors(response)
      if (response !== undefined) {
        throw response
      }
    }
  }

  async blob (requestType, url, payload) {
    try {
      const response = await axios({
        method: requestType,
        url: url,
        data: payload,
        responseType: 'blob'
      })
      // withCredentials: true,
      if (response.status !== 200) {
        this.displayErrors(response)
      }
      return response.data
    } catch ({ response }) {
      this.displayErrors(response)
      throw response
    }
  }

  displayErrors (response) {
    const errorsArray = []
    errorsArray.push(response.status + ': ' + response.statusText)

    if (response.data.message !== undefined) {
      errorsArray.push(response.data.message)
    }
    const alertData = {
      variant: 'danger',
      message: 'Warning',
      alerts: errorsArray
    }
    store.dispatch('setPageAlertInformation', alertData)
  }
}

export default Api
